import * as React from 'react';
import { styles } from './styles';
import { DemoSection, DemoSectionProps } from '../components/DemoSection';
import { Columns } from '@joykit';
import { Layout } from '@graphql/types';
import { SelectableOption } from '../../SelectableOption';
import { AlohaSVG } from './components/AlohaSVG';
import { BrannanSVG } from './components/BrannanSVG';
import { capitalize } from 'utils/strings';

const getSVGForLayout = (layout: Layout): React.ComponentType<any> => {
  switch (layout) {
    case 'aloha':
      return AlohaSVG;
    case 'brannan':
      return BrannanSVG;
    default:
      return AlohaSVG;
  }
};
const renderLayoutOptions = (currentLayout: Layout, onThemeSelect: Props['onSelect'], layouts: Layout[]) => {
  return (
    <Columns>
      {layouts.map(layout => {
        const Svg = getSVGForLayout(layout);
        const selected = currentLayout === layout;
        return (
          <Columns.Column key={layout}>
            <SelectableOption
              section="layout"
              value={layout}
              aria-label={`Select '${capitalize(layout)}' layout`}
              title={`Select '${capitalize(layout)}' layout`}
              onClick={selected ? undefined : onThemeSelect}
              className={styles.layoutOptionContainer(selected)}
            >
              <div className={styles.svgContainer}>
                <Svg />
              </div>
              <div>{capitalize(layout)}</div>
            </SelectableOption>
          </Columns.Column>
        );
      })}
    </Columns>
  );
};

interface Props extends DemoSectionProps {
  layout: Layout;
  onSelect: React.MouseEventHandler<HTMLElement>;
}

export const LayoutDesign: React.SFC<Props> = ({ open, layout, onSelect, onSectionToggle }) => {
  const subtitle = capitalize(layout);
  const content = open ? renderLayoutOptions(layout, onSelect, [Layout.aloha, Layout.brannan]) : null;
  return (
    <DemoSection
      open={open}
      onSectionToggle={onSectionToggle}
      section="layout"
      name="Change Page Layout"
      subtitle={subtitle}
    >
      {content}
    </DemoSection>
  );
};
